import { Form, Modal } from "antd";
import React from "react";
import { CreateRadiologyPointDto } from "../../../api";
import { radiologyPointsColumns } from "../form/columns";

interface RadiologyPointFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateRadiologyPoint: (values: CreateRadiologyPointDto) => void;
}

export const RadiologyPointForm: React.FC<RadiologyPointFormProps> = ({ visible, setVisible, onCreateRadiologyPoint }) => {
  const [form] = Form.useForm<CreateRadiologyPointDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateRadiologyPoint}>
        {radiologyPointsColumns.map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
          {inputNode}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
